"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderAccessAuth = exports.AccessAuthenticationWithHydration = void 0;
var hydrationHelpers_1 = require("@CommonFrontend/Public/Widgets/hydrationHelpers");
var react_1 = __importDefault(require("react"));
var server_1 = __importDefault(require("react-dom/server"));
var AccessAuthentication_1 = __importDefault(require("./AccessAuthentication"));
exports.AccessAuthenticationWithHydration = (0, hydrationHelpers_1.withHydrationHost)(AccessAuthentication_1.default, {
    componentName: "AccessAuthentication",
});
var renderAccessAuth = function (props) {
    return server_1.default.renderToString(react_1.default.createElement(exports.AccessAuthenticationWithHydration, props));
};
exports.renderAccessAuth = renderAccessAuth;
